import { useState, useEffect, useCallback } from 'react';
import { useCatalog } from '../products/use-catalog';
import { ClientEntity } from '../../../domain/entities/client.entity';

export const useClients = () => {
  const { getClientsUseCase } = useCatalog();
  const [clients, setClients] = useState<ClientEntity[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchClients = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getClientsUseCase.execute();
      setClients(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar clientes asociados');
    } finally {
      setLoading(false);
    }
  }, [getClientsUseCase]);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  return {
    clients,
    loading,
    error,
    refetch: fetchClients,
  };
};
